var fileDownload = {
	data() {
		return {
			listFileDownloads: [],
			searchingFileDownload: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		getAllFileDownloads() {
			this.searchingFileDownload = true
			let url = this.getApiBackend + 'fileDownloads'
			this.axiosAWNasyncBlock('Buscando descargas', 'POST', url, 'getAllFileDownloadsResult', null)
		},
		getAllFileDownloadsResult(response) {
			this.searchingFileDownload = false
			if (response.data.success == true) {
				this.listFileDownloads = response.data.data
			}
		}
	},
}

export default fileDownload;